import { Component, inject } from "@angular/core";
import { RdxDialogCloseDirective, RdxDialogTitleDirective, RdxDialogDescriptionDirective } from "@radix-ng/primitives/dialog";
import { SequenceService } from "@services/sequence.service";

@Component({
  selector: "app-abort-sequence-modal",
  standalone: true,
  imports: [RdxDialogCloseDirective, RdxDialogTitleDirective, RdxDialogDescriptionDirective],
  template: `
    <div
      class="alert-modal modal modal-small"
      data-testid="abort-sequence-modal"
      role="alertdialog"
      aria-labelledby="abort-sequence-modal-title"
      aria-describedby="abort-sequence-modal-description"
    >
      <h2 id="abort-sequence-modal-title" class="abort-sequence-modal__title title-h4" rdxDialogTitle>Arrêter la série d'exercices?</h2>
      <p id="abort-sequence-modal-description" class="abort-sequence-modal__description body-3" rdxDialogDescription>
        Tes progrès dans la série seront perdus si tu quittes sans l'avoir terminé.
      </p>
      <div class="modal-actions">
        <button class="btn btn-secondary modal-action" rdxDialogClose>Retour à l'exercice</button>
        <button class="btn btn-primary modal-action" (click)="handleShowResults()" rdxDialogClose>Voir mes résultats</button>
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;

    .abort-sequence-modal__title {
      margin-bottom: 1rem;
      text-align: center;
    }
    .abort-sequence-modal__description {
      text-align: center;
    }
  `,
})
export class AbortSequenceModal {
  private sequenceService = inject(SequenceService);

  handleShowResults() {
    this.sequenceService.abortSequence();
  }
}
